/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Col, Input, message, Button,
} from 'antd';
import { getTiposDeVialidades } from 'api/catalogos/tiposVialidades';
import Select from 'components/Select';
import ModalSearch from 'components/Direccion/ModalSearch';
import { getCodigosPostales } from 'api/catalogos';

// eslint-disable-next-line react/prop-types
const DireccionEntidad = ({
  formDireccion,
  rules,
  coloniasCargadas,
  paises,
  mutable,
  permission,
  disabled = false,
}) => {
  const [tiposDeVialidades, setTiposDeVialidades] = useState([]);
  const [visibleNoSeCodigo, setVisibleNoSeCodigo] = useState(false);
  const [colonias, setColonias] = useState([]);

  useEffect(() => {
    let mounted = true;

    const fetch = async () => {
      const [
        _tiposDeVialidades,
      ] = await Promise.all([
        getTiposDeVialidades(),
      ]);
      if (mounted) {
        setTiposDeVialidades(_tiposDeVialidades);
      }
    };
    fetch();
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    setColonias(coloniasCargadas);
  }, [coloniasCargadas]);

  const getFromPostalCode = (param) => {
    setTimeout(async () => {
      const _codigosPostales = await getCodigosPostales({ d_codigo: param });
      if (_codigosPostales.length) {
        const [firstItem] = _codigosPostales;
        const coloniasArr = _codigosPostales.map((item) => ({
          id: item.id, colonia: item.d_asenta,
        }));
        setColonias(coloniasArr);
        if (_codigosPostales.length === 1) {
          formDireccion.setFieldsValue({
            codigo_postal: firstItem.id,
            colonia: firstItem.d_asenta,
            d_codigo: firstItem.d_codigo,
            estado: firstItem.municipio.estado.nombre_de_AGEE,
            municipio: firstItem.municipio.nom_mun,
          });
        } else {
          formDireccion.setFieldsValue({
            pais: 'México',
            codigo_postal: firstItem.id,
            d_codigo: firstItem.d_codigo,
            estado: firstItem.municipio.estado.nombre_de_AGEE,
            municipio: firstItem.municipio.nom_mun,
            colonia: firstItem.d_asenta,
          });
        }
      } else {
        message.info('No se encontro información relacionada al código postal brindado');
        formDireccion.setFieldsValue({
          pais: 'México',
          codigo_posta: undefined,
          d_codigo: undefined,
          estado: undefined,
          municipio: undefined,
          colonia: undefined,
        });
      }
    }, 300);
  };

  const onFinishSearch = async (values) => {
    if (values) {
      const _codigosPostales = await getCodigosPostales({ d_codigo: values.d_codigo });
      if (_codigosPostales.length) {
        const coloniasArr = _codigosPostales.map((item) => ({
          id: item.id, colonia: item.d_asenta,
        }));
        setColonias(coloniasArr);
        formDireccion.setFieldsValue({
          codigo_postal: values.id,
          colonia: values.d_asenta,
          d_codigo: values.d_codigo,
          estado: values.nombre_de_AGEE,
          municipio: values.municipio.nom_mun,
        });
      } else {
        message.warn('Seleccione un elemento');
      }
    }
  };

  return (
    <Form
      layout="vertical"
      form={formDireccion}
      scrollToFirstError
      name="general"
      disabled={disabled}
      initialValues={{ pais: 'México', estados_globales: 1 }}
      onValuesChange={async (changedValues) => {
        if (changedValues.d_codigo?.length === 5) {
          getFromPostalCode(changedValues.d_codigo);
        }
      }}
    >
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="codigo_postal" hidden>
        <Input />
      </Form.Item>
      <Row gutter={10}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="d_codigo"
            label="Código Postal"
            hasFeedback={mutable}
            rules={rules.required}
          >
            <Input
              disabled={!mutable && (permission?.add || permission?.change)}
              allowClear
            />
          </Form.Item>

        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item>
            <br />
            <Button
              type="link"
              onClick={() => setVisibleNoSeCodigo(true)}
              className="primary-on-hover"
              disabled={!mutable && (permission?.add || permission?.change)}
            >
              No sé mi código
            </Button>
          </Form.Item>
        </Col>
        <Col span={24} />
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="pais"
            label="País"
            hasFeedback={mutable}
          >
            <Select
              labelProp="nombre"
              dataSource={paises}
              disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="estado"
            label="Estado"
            hasFeedback={mutable}
          >
            <Input allowClear disabled />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="municipio"
            label="Municipio"
            hasFeedback={mutable}
          >
            <Input allowClear disabled />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="colonia"
            label="Colonia"
            hasFeedback={mutable}
          >
            <Select
              valueProp="colonia"
              labelProp="colonia"
              keyProp="id"
              dataSource={colonias}
              onChange={(value) => {
                if (value === undefined) {
                  formDireccion.setFieldsValue({ colonia: null });
                }
              }}
              disabled={!mutable && (permission?.add || permission?.change)}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="numero_exterior"
            label="Número Exterior"
            rules={rules.required}
            hasFeedback={mutable}
          >
            <Input
              disabled={!mutable && (permission?.add || permission?.change)}
              allowClear
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="numero_interior"
            label="Número Interior"
            hasFeedback={mutable}
          >
            <Input
              disabled={!mutable && (permission?.add || permission?.change)}
              allowClear
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Input.Group style={{ display: 'flex' }} className="select-input" compact>
            <Form.Item
              style={{ width: 150 }}
              name="tipo_de_vialidad"
              label="Tipo"
              rules={rules.required}
              hasFeedback={mutable}
            >
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiposDeVialidades}
                disabled={!mutable && (permission?.add || permission?.change)}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%' }}
              name="calle_principal"
              label="Vialidad"
              hasFeedback={mutable}
              rules={rules.required}
            >
              <Input
                disabled={!mutable && (permission?.add || permission?.change)}
                allowClear
              />
            </Form.Item>
          </Input.Group>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Input.Group style={{ display: 'flex' }} className="select-input" compact>
            <Form.Item
              style={{ width: 150 }}
              name="tipo_de_vialidad_entre"
              label="Tipo"
              hasFeedback={mutable}
            >
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiposDeVialidades}
                disabled={!mutable && (permission?.add || permission?.change)}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%' }}
              name="entre_calle"
              label="Entre Vialidad"
              hasFeedback={mutable}
            >
              <Input
                disabled={!mutable && (permission?.add || permission?.change)}
                allowClear
              />
            </Form.Item>
          </Input.Group>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Input.Group style={{ display: 'flex' }} className="select-input" compact>
            <Form.Item
              style={{ width: 150 }}
              name="tipo_de_vialidad_y_calle"
              label="Tipo"
              hasFeedback={mutable}
            >
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiposDeVialidades}
                disabled={!mutable && (permission?.add || permission?.change)}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%' }}
              name="y_calle"
              label="Y Vialidad"
              hasFeedback={mutable}
            >
              <Input
                disabled={!mutable && (permission?.add || permission?.change)}
                allowClear
              />
            </Form.Item>
          </Input.Group>
        </Col>
        <Col span={24}>
          <Form.Item
            name="descripcion_de_la_ubicacion"
            label="Descripción de la Ubicación"
            hasFeedback={mutable}
          >
            <Input.TextArea
              autoSize={{ minRows: 2, maxRows: 3 }}
              maxLength={250}
              disabled={!mutable && (permission?.add || permission?.change)}
              allowClear
            />
          </Form.Item>
        </Col>
        <ModalSearch
          callback={onFinishSearch}
          setVisible={setVisibleNoSeCodigo}
          open={visibleNoSeCodigo}
        />
      </Row>
    </Form>
  );
};

export default DireccionEntidad;
